import Vue from "vue";

type TContext = 'simple' | 'workarea';

export default Vue.extend({
  props: {
    model: {
      type: Object,
      required: true,
    },
    context: {
      type: String as () => TContext,
      default: 'workarea',
    },
    fallback: {
      type: String,
      default: 'None',
    },
    cantFallback: {
      type: String,
      default: 'N/A',
    },
    showFallback: {
      type: Boolean,
      default: false,
    },
  },
});
